import * as RadixTabs from "@radix-ui/react-tabs";
import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/cn";

export const TabsTrigger = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<typeof RadixTabs.Trigger>
>(({ className, ...props }, ref) => (
  <RadixTabs.Trigger
    ref={ref}
    className={cn(
      "px-2.5 py-1.5 text-xs font-semibold rounded-md text-fg-mute",
      "transition-colors",
      "hover:text-fg",
      "data-[state=active]:bg-surface-tint data-[state=active]:text-violet",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet/50",
      className,
    )}
    {...props}
  />
));
TabsTrigger.displayName = "TabsTrigger";
